﻿import tippy from 'tippy.js';

(function (document) {

  document.ReinitializeTippy = function () {
    var elems = document.querySelectorAll('[data-tippy-content]')

    for (var i = 0; i < elems.length; i++) {
      if (!elems[i].dataset.tippyEnabled) {
        tippy(elems[i]);
        elems[i].dataset.tippyEnabled = true;
      }
    }
  };

  document.addEventListener('DOMContentLoaded', function (e) {
    document.ReinitializeTippy();
  });
})(document);


(function (document) {

  function ReinitializeTippyMenus() {
    var tippyWrappers = document.querySelectorAll('[data-tippy-custom-wrapper]');
    if (tippyWrappers != null) {
      for (var i = 0; i < tippyWrappers.length; i++) {
        var toggle, content;
        toggle = tippyWrappers[i].querySelector('[data-tippy-custom-toggle]');
        content = tippyWrappers[i].querySelector('[data-tippy-custom-content]');
        var placement = toggle.dataset.tippyPlacement ? toggle.dataset.tippyPlacement : "top";

        if (content && content.style) {
          content.style.display = 'block';
        }

        tippy(
          toggle, {
          theme: 'light',
          content: content,
          trigger: 'click',
          interactive: 'true',
          triggerTarget: toggle,
          placement: placement,
        }
        );
      }
    }
  };

  document.addEventListener('DOMContentLoaded', function (e) {
    ReinitializeTippyMenus()
  });


  document.addEventListener('DashboardLoaded', function (e) {
    document.ReinitializeTippy();
  });
})(document);